<template>

  <ValidationObserver v-slot="{ invalid }">

    <vx-card>

      <div class="vx-row">
        <div class="vx-col">
          <h5 class="mb-2"> {{ $t('vdo-live-set-topic.edit-title') }} {{ editTitle }}</h5>
          <h6 style="color: rgb(184, 194, 204);">
            {{ $t('vdo-live-set-topic.edit-sub-title') }} {{ editSubTitle }}
          </h6>
        </div>
      </div>

      <vs-divider/>

      <div class="vx-row">
        <!------------------------------------------ Left Side ---------------------------------------------------------->
        <div class="vx-col sm:w-2/5 w-full mi-border-right">

          <div class="vx-row">
            <div class="vx-col w-1/2 pt-1">
              <h5> {{ $t('vdo-live-set-topic.sub-topic') }} </h5>
            </div>

            <div class="vx-col w-1/2 pr-5">
              <vx-tooltip :text="$t('general.add') + $t('vdo-live-set-topic.sub-topic')" class="float-right">
                <vs-button :disabled="isUploading" @click="onAddClick" color="dark" icon="icon-plus" icon-pack="feather"
                           radius
                           size="small" type="border">
                </vs-button>
              </vx-tooltip>
            </div>

          </div>

          <div class="vs-row">
            <div class="vx-col w-full">
              <vs-list>
                <vs-list-item :class="setSelectedClass(item)" :icon="item.vdoStreamPath ? 'icon-video':'icon-video-off'"
                              :key="index"
                              :subtitle="setVdoLengthLabel(item.vdoLength)"
                              :title="item.no + '. ' +item.nameLocal"
                              class="hover:text-primary"
                              icon-pack="feather"
                              v-for="(item, index) in vdoLiveSetTopics">

                  <vx-tooltip :text="$t('general.edit') + $t('vdo-live-set-topic.sub-topic')" class="float-right">
                    <feather-icon @click="onEditClick(item)" class="cursor-pointer" icon="EditIcon"
                                  svgClasses="w-5 h-5 hover:text-primary stroke-current"/>
                  </vx-tooltip>
                </vs-list-item>
              </vs-list>


              <vs-alert :active="showWarningNoTopics" color="warning" icon="icon-alert-triangle" icon-pack="feather">
                {{ $t('vdo-set-topic.no-vdo-set-topic')}}
              </vs-alert>

            </div>
          </div>

        </div>

        <!-----------------------------form------------- Right Side --------------------------------------------------------->
        <div class="vx-col sm:w-3/5 w-full">

          <div class="vs-row">
            <div class="vx-col w-full mb-2">
              <h5> {{ vdoLiveSetTopicFormHeader }} </h5>
            </div>
          </div>

          <vs-divider/>

          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <ValidationProvider :name="$t('vdo-set-topic.no')" rules="required|numeric" v-slot="{ errors }">
                <vs-input :label="$t('vdo-set-topic.no') + ' *'" class="w-full"
                          v-model.number="form.vdoLiveSetTopicInput.no"/>
                <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <ValidationProvider :name="$t('vdo-live-set-topic.name-local')" rules="required" v-slot="{ errors }">
                <vs-input :label="$t('vdo-live-set-topic.name-local') + ' *'" class="w-full"
                          v-model="form.vdoLiveSetTopicInput.nameLocal"/>
                <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input :label="$t('vdo-live-set-topic.name-eng')" class="w-full"
                        v-model="form.vdoLiveSetTopicInput.nameEng"/>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full mb-2">
              <label class="text-sm">{{$t('vdo-set-topic.remark')}}</label>
              <vs-textarea rows="2" v-model="form.vdoSetTopicInput.remark"/>
            </div>
          </div>

          <div class="vx-row" v-if="showFileUpload">
            <div class="vx-col w-full -mx-2 p-0">
              <div id="uploadVdoInput">
                <vs-upload-mod :accept="uploadAcceptVdoType"
                               :action="uploadVdoUrl"
                               :data="uploadPayload"
                               :multiple="false"
                               :text="$t('vdo-set-topic.upload-vdo')"
                               @change="onFileUploadChange"
                               @on-error="onUploadError"
                               @on-success="onUploadSuccess"
                               automatic
                               class="m-0 p-0"
                />
              </div>

              <!--<div class="upload-img mt-5" v-if="!dataImg">
                <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
                <vs-button @click="$refs.uploadImgInput.click()">Upload Image</vs-button>
              </div>-->
            </div>
          </div>

          <!----------------------------------------- Actions Button ---------------------------------------------------->
          <div class="vx-row pt-2">
            <div class="vx-col w-full">
              <vs-button :disabled="local.isProcessing || invalid || isUploading"
                         @click.prevent="onSaveClick">
                {{ $t('general.save') }}
              </vs-button>
              <vs-button :disabled="local.isProcessing || isUploading"
                         @click.prevent="onDeleteClick"
                         class="ml-2" color="danger"
                         v-if="showDeleteButton">
                {{ $t('general.delete') }}
              </vs-button>
            </div>
          </div>

        </div>

      </div>

    </vx-card>


  </ValidationObserver>
</template>

<script>
  import {state, setEmptyVdoLiveSetTopicForm} from '../data';
  import {secondToHHMMSSFormat} from "@/utils/data";
  import {showStateNotification, showLocalNotification, notificationType} from "@/utils/notification";
  import {confirmDelete, confirmSave} from "@/utils/dialogs";
  import {config} from "@/utils/upload";
  import vsUploadMod from '@/components/vuesax-mod/components/vsUpload/vsUpload'

  import VdoLiveSetTopic from '@/store/modules/live-class/vod-live-set-topic/index';
  import {createHelpers} from 'vuex-map-fields';
  import {createNamespacedHelpers} from "vuex";

  if (!state.store.VdoLiveSetTopic) state.registerModule(`VdoLiveSetTopic`, VdoLiveSetTopic);

  const {
    mapActions: mapVdoLiveSetTopicActions,
  } = createNamespacedHelpers(`VdoLiveSetTopic`);


  const {
    mapFields: mapVdoLiveSetTopicFields,
  } = createHelpers({
    getterType: `VdoLiveSetTopic/getField`,
    mutationType: `VdoLiveSetTopic/updateField`,
  });


  export default {
    components: {
      vsUploadMod,
    },
    data() {
      return {
        store: state.store,
        local: state.local,

        vdoLiveSetEdit: state.local.vdoLiveSetEdit,
        vdoLiveSetTopicEdit: state.local.vdoLiveSetTopicEdit,
        form: state.local.vdoLiveSetTopicEdit.form,

        uploadAcceptVdoType: config.fileExtension.video,
        uploadVdoUrl: config.url.liveVdoApi,
        uploadPayload: {
          fileName: '',
          fileNameUpload: '',
          vdoLiveSetTopicId: '',
          liveClassScheduleId: '',
          vdoLength: 0,
          //TODO: get customerPrefix from token
          customerPrefix: 'Extra',
        },
        uploadVdo: {},
      }
    },
    computed: {
      ...mapVdoLiveSetTopicFields({
        vdoLiveSetTopicProcessing: 'processing',
        vdoLiveSetTopicSuccess: 'success',
        vdoLiveSetTopicError: 'error'
      }),
      editTitle() {
        if (this.vdoLiveSetEdit.vdoLiveSet) {
          return this.vdoLiveSetEdit.vdoLiveSet.liveClassSchedule.courseOutlineUnit.seq
            + '. ' + this.vdoLiveSetEdit.vdoLiveSet.liveClassSchedule.courseOutlineUnit.nameLocal;
        }
        return '-'
      },
      editSubTitle() {
        if (this.vdoLiveSetEdit.vdoLiveSet) {
          return this.vdoLiveSetEdit.vdoLiveSet.liveClassSchedule.topicLocal;
        }
        return '-'
      },
      isUploading() {
        return this.local.isUploading
      },
      vdoLiveSetTopics() {
        return this.vdoLiveSetTopicEdit.vdoLiveSetTopics;
      },
      vdoLiveSetTopicFormHeader() {
        if (this.vdoLiveSetTopicEdit.selectedVdoLiveSetTopic) {
          return this.$t('general.edit') + this.$t('vdo-live-set-topic.sub-topic');
        } else {
          return this.$t('general.add') + this.$t('vdo-live-set-topic.sub-topic');
        }
      },
      showWarningNoTopics() {
        if (!this.vdoLiveSetTopicEdit.vdoLiveSetTopics
          || this.vdoLiveSetTopicEdit.vdoLiveSetTopics.length > 0) {
          return false;
        }
        return true;
      },
      showFileUpload() {
        if (this.vdoLiveSetTopicEdit.selectedVdoLiveSetTopic && this.vdoLiveSetTopicEdit.selectedVdoLiveSetTopic.id) {
          return true;
        } else {
          return false;
        }
      },
      showDeleteButton() {
        if (this.vdoLiveSetTopicEdit.selectedVdoLiveSetTopic && this.vdoLiveSetTopicEdit.selectedVdoLiveSetTopic.id) {
          return true;
        } else {
          return false;
        }
      },
    },
    watch: {
      vdoLiveSetTopicProcessing(data) {
        this.local.isProcessing = data;
      },
      vdoLiveSetTopicSuccess(data) {
        showStateNotification(this.$vs, data);
      },
      vdoLiveSetTopicError(data) {
        showStateNotification(this.$vs, data);

      }
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapVdoLiveSetTopicActions({
        getVdoLiveSetTopic: 'getVdoLiveSetTopic',
        addVdoLiveSetTopic: 'addVdoLiveSetTopic',
        updateVdoLiveSetTopic: 'updateVdoLiveSetTopic',
        deleteVdoLiveSetTopic: 'deleteVdoLiveSetTopic',
      }),
      //---------------------------------------- Event Function ------------------------------------------------------//
      onAddClick() {
        if (!this.local.isUploading) {
          setEmptyVdoLiveSetTopicForm();
        }
      },
      onEditClick(selectedData) {
        if (!this.local.isUploading) {
          this.vdoLiveSetTopicEdit.selectedVdoLiveSetTopic = selectedData;

          this.form.vdoLiveSetTopicInput.no = selectedData.no;
          this.form.vdoLiveSetTopicInput.nameLocal = selectedData.nameLocal;
          this.form.vdoLiveSetTopicInput.nameEng = selectedData.nameEng;
          this.form.vdoLiveSetTopicInput.vdoLength = selectedData.vdoLength;
          this.form.vdoLiveSetTopicInput.vdoStreamPath = selectedData.vdoStreamPath;

          //set id for api upload
          this.uploadPayload.vdoLiveSetTopicId = selectedData.id;
          this.uploadPayload.liveClassScheduleId = this.vdoLiveSetEdit.vdoLiveSet.liveClassSchedule.id;
        }
      },
      async onSaveClick() {
        let payload = this.prepareDataBeforeSave();
        confirmSave(this.$vs, this.saveVdoLiveSetTopic, payload);
      },
      async onDeleteClick() {
        let payload = {
          id: this.vdoLiveSetTopicEdit.selectedVdoLiveSetTopic.id
        }
        confirmDelete(this.$vs, this.removeVdoLiveSetTopic, payload);
      },
      onPreviewClick() {
        //open popup
        this.showPreviewVideoPopUp = true;
      },
      async onFileUploadChange(event, files) {
        this.local.isUploading = true;
        this.setVdoInfo(files, this.uploadPayload);
      },
      async onUploadSuccess() {
        //call update function
        await this.updateVdoLength();

        showLocalNotification(this.$vs, this.$t('general.success')
          , this.$t('upload.upload-vdo-success', {fileName: this.uploadPayload.fileName})
          , notificationType.SUCCESS);
        this.local.isUploading = false;
      },
      onUploadError() {
        showLocalNotification(this.$vs, this.$t('general.error')
          , this.$t('upload.upload-vdo-fail', {fileName: this.uploadPayload.fileName})
          , notificationType.ERROR);
        this.local.isUploading = false;
      },
      //---------------------------------------- Local Function ------------------------------------------------------//
      async saveVdoLiveSetTopic(payload) {

        let result;
        if (!payload.id) {
          result = await this.addVdoLiveSetTopic(payload);
        } else {
          result = await this.updateVdoLiveSetTopic(payload);
        }

        if (result) {
          this.updateListAfterSave(payload, result);
        }

      },
      async removeVdoLiveSetTopic(payload) {
        let result = await this.deleteVdoLiveSetTopic(payload);

        // remove list
        if (result) {
          this.updateListAfterDelete(result);
        }

      },
      async updateVdoLength() {
        let payload = {
          id: this.vdoLiveSetTopicEdit.selectedVdoLiveSetTopic.id,
          vdoLiveSetTopicInput: {
            vdoLength: parseInt(this.uploadPayload.vdoLength.toFixed(0)),
          }
        };
        let result = await this.updateVdoLiveSetTopic(payload);

        if (result) {
          this.updateListAfterSave(payload, result);
        }
      },
      prepareDataBeforeSave() {
        let vdoLength = this.form.vdoLiveSetTopicInput.vdoLength;
        if (this.uploadPayload.vdoLength > 0) {
          vdoLength = this.uploadPayload.vdoLength;
        }

        let payload = {
          vdoLiveSetTopicInput: {
            ...this.form.vdoLiveSetTopicInput,

            //set vdo duration here
            vdoLength: parseInt(vdoLength),
          }
        };
        if (this.vdoLiveSetTopicEdit.selectedVdoLiveSetTopic && this.vdoLiveSetTopicEdit.selectedVdoLiveSetTopic.id) {
          //edit
          payload['id'] = this.vdoLiveSetTopicEdit.selectedVdoLiveSetTopic.id;
        } else {
          //insert
          payload['vdoLiveSetId'] = this.vdoLiveSetEdit.vdoLiveSet.id;
        }

        return payload
      },
      setVdoLengthLabel(vdoLength) {
        let totalVdoLength = '00:00:00';
        if (vdoLength) {
          totalVdoLength = secondToHHMMSSFormat(vdoLength);
        }
        return totalVdoLength;
      },
      setSelectedClass(item) {
        let selectedClass = '';
        if (this.vdoLiveSetTopicEdit.selectedVdoLiveSetTopic && item.id === this.vdoLiveSetTopicEdit.selectedVdoLiveSetTopic.id) {
          return 'text-primary'
        }
        return selectedClass;
      },
      updateListAfterSave(payload, result) {
        //deep copy so we can mutate data
        result = JSON.parse(JSON.stringify(result));
        if (!payload.id) {
          //add new vdoLiveSetTopic to vdoLiveSetTopics list
          this.vdoLiveSetTopicEdit.vdoLiveSetTopics.push(result);

        } else {
          //update new vdoLiveSetTopic to vdoLiveSetTopics list
          const index = this.vdoLiveSetTopicEdit.vdoLiveSetTopics.findIndex(item => {
            return item.id === result.id
          });
          this.vdoLiveSetTopicEdit.vdoLiveSetTopics[index] = result;

        }
        this.vdoLiveSetTopicEdit.selectedVdoLiveSetTopic = result;
        this.setTotalVdoLength(result);
      },
      updateListAfterDelete(result) {
        //remove from list
        const index = this.vdoLiveSetTopicEdit.vdoLiveSetTopics.findIndex(item => item.id === result.id);
        this.vdoLiveSetTopicEdit.vdoLiveSetTopics.splice(index, 1);

        setEmptyVdoLiveSetTopicForm();
        this.setTotalVdoLength(result);

      },
      setTotalVdoLength(result) {
        this.vdoLiveSetEdit.vdoLiveSet.totalVdoLength = result.vdoLiveSet.totalVdoLength;
      },
      setVdoInfo(files, uploadPayload) {
        //set upload file name

        let fileExtension = files[0].name.split('.').pop();
        uploadPayload.fileName = files[0].name;
        uploadPayload.fileNameUpload = config.prefixFileName.vdoLiveSet
                                      + '_' + this.vdoLiveSetEdit.vdoLiveSet.liveClassSchedule.subject.code
                                      + '_' + this.vdoLiveSetEdit.vdoLiveSet.id
                                      + '_' + this.vdoLiveSetTopicEdit.selectedVdoLiveSetTopic.id
                                      + '.' + fileExtension

        let video = document.createElement('video');

        video.preload = 'metadata';
        video.onloadedmetadata = function () {
          window.URL.revokeObjectURL(video.src);
          uploadPayload.vdoLength = video.duration;
        }

        //for preview
        video.src = URL.createObjectURL(files[0]);
        //set vdo duration at sending data
        return video;
      }
    },
  }
</script>

<style scoped>

</style>
